import Vue from "vue"
import Vuex from "vuex"
import getSystemInfo from "../utils/getSystemIno"

import toast from "./module/toast"
import loading from "./module/loading"
import userInfo from "./module/userInfo"
import contribute from "./module/contribute"
import home from "./module/home"
import workDetail from "./module/workDetail"
import myWork from "./module/myWork"
import activityInfo from "./module/activityInfo"
import slideVerify from "./module/slideVerify"
import workCollection from "./module/workCollection"
import signInPopup from "./module/signInPopup"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    toast,
    loading,
    userInfo,
    contribute,
    home,
    workDetail,
    myWork,
    activityInfo,
    slideVerify,
    workCollection,
    signInPopup
  },
  state: {
    systemInfo: {
      ios: false,
      pc: false,
      android: false,
      isWx: false,
      isPhoneX: false,
      isNfPlus: false
    },
    openAppOptions: {
      show: false,
      tips: ""
    }
  },
  getters: {
    systemInfo: state => state.systemInfo,
    openAppOptions: state => state.openAppOptions
  },
  mutations: {
    setSystemInfo(state, systemInfo) {
      state.systemInfo = systemInfo
    },
    showOpenApp(state, tips) {
      state.openAppOptions.tips = tips
      state.openAppOptions.show = true
    },
    closeOpenApp(state) {
      state.openAppOptions.show = false
    }
  },
  actions: {
    async getSystemInfo({ commit }) {
      const systemInfo = await getSystemInfo()
      commit("setSystemInfo", systemInfo)
    }
  }
})
